type RouteHandler = (params: Record<string, string>) => void;

interface Route {
  pattern: RegExp;
  paramNames: string[];
  handler: RouteHandler;
}

export class Router {
  private routes: Route[] = [];
  private currentPath: string = '';
  private hashChangeHandler: () => void;

  constructor() {
    this.hashChangeHandler = () => this.resolve();
    window.addEventListener('hashchange', this.hashChangeHandler);
  }

  on(path: string, handler: RouteHandler): void {
    // Convert "/profile/:userId" to regex with named groups
    const paramNames: string[] = [];
    const pattern = path.replace(/:(\w+)/g, (_, name) => {
      paramNames.push(name as string);
      return '([^/]+)';
    });
    this.routes.push({
      pattern: new RegExp('^' + pattern + '$'),
      paramNames,
      handler,
    });
  }

  resolve(): void {
    const hash = window.location.hash.slice(1) || '/';
    if (hash === this.currentPath) return;
    this.currentPath = hash;

    for (const route of this.routes) {
      const match = hash.match(route.pattern);
      if (match) {
        const params: Record<string, string> = {};
        route.paramNames.forEach((name, i) => {
          params[name] = match[i + 1]!;
        });
        route.handler(params);
        return;
      }
    }
  }

  navigate(path: string): void {
    window.location.hash = path;
  }

  getCurrentPath(): string {
    return this.currentPath;
  }

  destroy(): void {
    window.removeEventListener('hashchange', this.hashChangeHandler);
  }
}
